import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";

const modules = [
  {
    title: "Introduction to DevOps",
    points: [
      "What is DevOps and its lifecycle",
      "DevOps culture and benefits",
      "Agile vs DevOps comparison",
      "Real-world DevOps use cases",
    ],
  },
  {
    title: "Linux Fundamentals",
    points: [
      "Linux commands and file system basics",
      "User and permission management",
      "Process and service management",
      "Shell scripting basics",
    ],
  },
  {
    title: "Version Control with Git",
    points: [
      "Introduction to Git and GitHub",
      "Branching, merging, and workflows",
      "Pull requests and collaboration",
      "Resolving merge conflicts",
    ],
  },
  {
    title: "CI/CD Pipeline",
    points: [
      "Introduction to Continuous Integration and Deployment",
      "Jenkins installation and setup",
      "Creating Jenkins pipelines",
      "Automated build and deployment process",
    ],
  },
  {
    title: "Containerization with Docker",
    points: [
      "Introduction to Docker and containers",
      "Docker images and containers lifecycle",
      "Writing Dockerfiles",
      "Docker Compose basics",
    ],
  },
  {
    title: "Orchestration with Kubernetes",
    points: [
      "Introduction to Kubernetes architecture",
      "Pods, Deployments, and Services",
      "ConfigMaps and Secrets",
      "Basic cluster management",
    ],
  },
  {
    title: "Cloud Platforms for DevOps",
    points: [
      "AWS/Azure basics for DevOps",
      "Deploying applications on cloud",
      "Managing infrastructure on cloud",
      "Scaling and load balancing concepts",
    ],
  },
  {
    title: "Infrastructure as Code (IaC)",
    points: [
      "Introduction to Terraform",
      "Writing infrastructure code",
      "Managing cloud resources using IaC",
      "Versioning infrastructure",
    ],
  },
  {
    title: "Monitoring & Logging",
    points: [
      "Introduction to monitoring tools",
      "Prometheus and Grafana basics",
      "Log management concepts",
      "Alerting and performance monitoring",
    ],
  },
  {
    title: "Real-Time DevOps Projects",
    points: [
      "End-to-end CI/CD pipeline implementation",
      "Dockerized application deployment",
      "Cloud-based application hosting",
      "Monitoring and scaling real applications",
    ],
  },
];
function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
      AOS.init({ duration: 800, once: true });
    }, []);

  return (
    <>
    <section className="syllabus-section">
      <div className="container">
        <div className="headlines-for-all">
          <h4   data-aos="fade-up">
            <span>Course </span> Syllabus
          </h4>
          <p  data-aos="fade-up">
            Explore our comprehensive DevOps syllabus — built for
            real-world projects, hands-on learning, and 100% job readiness.
          </p>
        </div>


        {/* ---------- Desktop Tabs ---------- */}
        {!isMobile && (
          <>
            <div className="custom-btn-group "   data-aos="fade-up">
              {modules.map((m, index) => (
                <button
                  key={index}
                  className={`custom-btn ${activeModule === index ? "active" : ""
                    }`}
                  onClick={() => setActiveModule(index)}
                >
                  Module {index + 1}
                </button>
              ))}
            </div>

            <div className="custom-module-container"   data-aos="fade-up">
              <div className="custom-module-box active">
                <h4>{modules[activeModule].title}</h4>
                <ul className="ul-list-module">
                  {modules[activeModule].points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
        {isMobile && (
          <div className="faq-container-course"   data-aos="fade-up">
            {modules.map((m, index) => (
              <div
                key={index}
                className={`faq-item-course ${activeModule === index ? "open" : ""
                  }`}
              >
                <button
                  className="faq-question-course"
                  onClick={() =>
                    setActiveModule(activeModule === index ? null : index)
                  }
                >
                  {m.title}
                  <span className="faq-icon-course">
                    {activeModule === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer-course"
                  style={{
                    maxHeight: activeModule === index ? "400px" : "0px",
                  }}
                >
                  <ul>
                    {m.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="btn-center"   data-aos="fade-up">
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
        </div>
      </div>
    </section>

  
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default CourseSyllabus;
